import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class WorkChecksTypesRequest extends GenericRequest {

    constructionId;
    year;
    month;
    companyId;

    constructor(constructionId, year, month, companyId) {
        super(METHOD_POST, ApiEndpoints.MONTLY_WORK_CHECK_TYPES);

        this.constructionId = constructionId;
        this.year = year;
        this.month = month;
        this.companyId = companyId;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.constructionId ) request.criteria.construction_id = this.constructionId;
        if ( this.year ) request.criteria.year = this.year;
        if ( this.month ) request.criteria.month = this.month;
        if ( this.companyId ) request.criteria.company_id = this.companyId;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/ws/WorkChecksTypesRequest.js